import LegacyWidgetLayoutAdapter from 'components/Widgets/LegacyWidgetLayoutAdapter';

const normalizeGridSpan = (value) => {
  const span = Number(value);
  return Number.isFinite(span) && span > 0 ? Math.floor(span) : 1;
};

const BaseMapWidgetContainer = ({ dimensions, children }) => {
  const columns = normalizeGridSpan(dimensions?.[0]);
  const rows = normalizeGridSpan(dimensions?.[1]);
  const layout = `${columns}x${rows}`;

  return (
    <LegacyWidgetLayoutAdapter dimensions={[columns, rows]} clipOverflow>
      {({ containerSizePx, adaptedLayout }) => (
        <div
          className="base-map-widget-container d-flex flex-column h-100 w-100 min-h-0 overflow-hidden position-relative"
          data-map-widget-layout={layout}
          data-map-widget-columns={columns}
          data-map-widget-rows={rows}
        >
          {typeof children === 'function'
            ? children({
                dimensions: [columns, rows],
                layout,
                containerSizePx,
                adaptedLayout,
              })
            : children}
        </div>
      )}
    </LegacyWidgetLayoutAdapter>
  );
};

export default BaseMapWidgetContainer;
